import axios from 'axios';

/**
 * AxiosApi
 */
const AxiosApi = axios.create({ baseURL: `${process.env.REACT_APP_API_BACKEND}` });

export default AxiosApi;
